import { useAuthStore } from '../stores/auth-store';

let redirecting = false;

// API clients throw an Error tagged `shouldRedirect: true` on any 401.
// Centralized here so *every* query/mutation triggers the same logout +
// redirect — previously only the `useAuth` `/me` query had a handler, so a
// session expiring mid-navigation just left other queries in a silent error
// state (rendered as missing/empty data) instead of logging the user out.
export function isSessionExpiredError(error: unknown): boolean {
  return !!(error as { shouldRedirect?: boolean } | null | undefined)?.shouldRedirect;
}

export function handleSessionExpired() {
  if (redirecting) return;
  redirecting = true;
  useAuthStore.getState().logout();
  window.location.href = import.meta.env.VITE_AUTH_API_URL
    ? `${import.meta.env.VITE_AUTH_API_URL}/auth/login`
    : 'http://localhost:8787/auth/login';
}
